export class ReInstateWithdrawReason{
    id: string;
    name: string;
}